<div class="stepper">
  <div
    class="step"
    *ngFor="let step of steps; let i = index; let last = last"
    [class.active]="step === currentStep"
    [class.completed]="step < currentStep"
    [class.last]="last"
  >
    <div class="circle">{{ step }}</div>

    <!-- línia només si NO és l'últim -->
    <div
      class="line"
      *ngIf="!last"
      [class.completed]="step < currentStep"
    ></div>
  </div>
</div>

